import React from 'react';
import { Typography } from 'antd';
import { FONT_SIZE, SPACING, RADIUS, SHADOW } from '../constants/constants';
import { useThemeTokens } from '../hooks/UseThemeTokens';
import { useTheme } from '../contexts/ThemeContext';
import wordmarkLight from '../assets/wordmark-light.png';
import wordmarkLight2x from '../assets/wordmark-light@2x.png';
import wordmarkNavy from '../assets/wordmark-navy.png';
import wordmarkNavy2x from '../assets/wordmark-navy@2x.png';

const { Title } = Typography;

interface Props {
  subtitle: string;
  children: React.ReactNode;
}

/**
 * 로그인·회원가입 공통 레이아웃.
 * 색상은 전부 디자인 시스템 토큰을 사용한다.
 */
export const AuthLayout: React.FC<Props> = ({ subtitle, children }) => {
  const t = useThemeTokens();
  // 밝은 상자에는 짙은 글자 워드마크, 다크 상자에는 흰 글자 워드마크.
  const { isDark } = useTheme();
  const wordmark = isDark ? wordmarkNavy : wordmarkLight;
  const wordmark2x = isDark ? wordmarkNavy2x : wordmarkLight2x;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: t.bgPage,
      }}
    >
      <div
        style={{
          width: 360,
          padding: SPACING['3xl'],
          borderRadius: RADIUS.xl,
          background: t.bgSurface,
          border: `1px solid ${t.border}`,
          boxShadow: SHADOW.panel,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: SPACING.xxl }}>
          {/* 워드마크(심벌 + CCT, 코덱 제작 2026-10-20)는 장식 — 이름은 아래 제목 글자가 읽힌다. */}
          <img
            src={wordmark}
            srcSet={`${wordmark2x} 2x`}
            width={248}
            height={32}
            alt=""
            style={{ display: 'block', margin: `0 auto ${SPACING.md}px` }}
          />
          <Title level={3} style={{ margin: 0, color: t.textPrimary }}>
            Card Control Tower
          </Title>
          <p
            style={{
              color: t.textSecondary,
              marginTop: SPACING.xs,
              fontSize: FONT_SIZE.sm,
            }}
          >
            {subtitle}
          </p>
        </div>

        {children}
      </div>
    </div>
  );
};